import React, { ReactElement, ReactNode } from 'react';

interface FooterProps {
  children: ReactNode;
}

export const Footer = ({ children }: FooterProps): ReactElement => <div className="buttons-footer">{children}</div>;
